var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediumRiskGuageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 425,
    height: 224,
    viewBox: "0 0 425 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.985 123.275L106.234 28.4432C42.7277 65.1949 0 133.853 0 212.5H109.485C109.485 174.374 130.201 141.085 160.985 123.275Z",
    fill: "#4ED27E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M212.5 109.485C231.269 109.485 248.859 114.503 264.015 123.275L318.766 28.4432C287.503 10.358 251.215 0 212.5 0C173.785 0 137.497 10.358 106.234 28.4432L160.985 123.275C176.141 114.503 193.732 109.485 212.5 109.485Z",
    fill: "#FEE17B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M318.766 28.4432L264.016 123.275C294.799 141.085 315.515 174.374 315.515 212.5H425C425 133.853 382.273 65.187 318.766 28.4432Z",
    fill: "#F84562"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M229.525 203.822L216.944 97.9494C216.175 92.8528 208.832 92.8528 208.063 97.9494L195.482 203.822H195.655C195.545 204.616 195.482 205.432 195.482 206.257C195.482 215.657 203.108 223.282 212.508 223.282C221.907 223.282 229.533 215.657 229.533 206.257C229.533 205.432 229.47 204.616 229.36 203.822H229.533H229.525ZM212.5 215.9C207.175 215.9 202.856 211.581 202.856 206.257C202.856 200.932 207.175 196.613 212.5 196.613C217.824 196.613 222.143 200.932 222.143 206.257C222.143 211.581 217.824 215.9 212.5 215.9Z",
    fill: "#434A60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumRiskGuageIcon);
export default __webpack_public_path__ + "static/media/MediumRiskGuageIcon.e6788568417786ade37f716cb685b262.svg";
export { ForwardRef as ReactComponent };